import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class InsuredContact extends BaseModel {
    @Expose() cellphoneNumber = "";
    @Expose() mainEmail = "";
    @Expose() otherEmails: string[] = [];
    @Expose() otherPhoneNumber: Nullable<string> = null;
    @Expose() phoneNumber: Nullable<string> = null;
}
